import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { authService } from '../../services/auth.service';
import { MustChangePasswordGuard } from './MustChangePasswordGuard';
import { AuthLoading } from './AuthSplitLayout';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const [isValidating, setIsValidating] = useState(true);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    const validateToken = async () => {
      try {
        // No need to check localStorage - tokens are in httpOnly cookies
        const response = await authService.validateToken();
        if (response) {
          setIsValid(true);
        } else {
          setIsValid(false);
        }
      } catch (error) {
        console.error('Token validation error:', error);
        setIsValid(false);
      } finally {
        setIsValidating(false);
      }
    };

    validateToken();
  }, []);

  if (isValidating) {
    return <AuthLoading />;
  }

  if (!isValid) {
    return <Navigate to="/login" replace />;
  }

  return (
    <MustChangePasswordGuard>
      {children}
    </MustChangePasswordGuard>
  );
}; 